import PropTypes from 'prop-types'
import classNames from 'classnames'
import styles from './Sidebar.css'

const propTypes = {
  tag: PropTypes.oneOfType([PropTypes.func, PropTypes.string]),
  className: PropTypes.string
}

const defaultProps = {
  tag: 'div'
}

const Sidebar = (props) => {
  const {
    className,
    tag: Tag,
    ...attributes
  } = props

  const classes = classNames(
    className,
    'side-bar',
    styles.sidebar
  )

  return (
    <Tag
      {...attributes}
      className={classes}
    />
  )
}

Sidebar.propTypes = propTypes
Sidebar.defaultProps = defaultProps

export default Sidebar
